import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';

const Challan_f = () => {
    const [formData, setFormData] = useState({
        sr_no: '',
        book_no: '',
        news_no: '',
        no: '',
        thana: '',
        district: '',
        date: '',
        time: '',
        r_date: '',
        r_time: '',
        name_news: '',
        crime: '',
        place: '',
        criminal_loc: '',
        operation: '',
        d_date: '',
        d_time: '',
        remarks: '',
        phone_no: '',
        token_id: 'E FIR - ',
        status_f: '',
        status_c: '',
        under_inquiry: '',
        paid_quiry: '',
        weapon: '',
        witness: '',
        crime_news: '',
        name: '',
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (token_Id) => {
        const canvas = createCanvas();
        JsBarcode(canvas, token_Id, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            const barcodeImage = generateBarcode(formData.token_id);
            setBarcodeImage(barcodeImage);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id) {
            setMessage("براہ کرم ضروری فیلڈز بھریں");
            return;
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/form.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'add',
                    ...formData,
                    barcode: barcodeImage
                })
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    sr_no: '',
                    book_no: '',
                    news_no: '',
                    no: '',
                    thana: '',
                    district: '',
                    date: '',
                    time: '',
                    r_date: '',
                    r_time: '',
                    name_news: '',
                    crime: '',
                    place: '',
                    criminal_loc: '',
                    operation: '',
                    d_date: '',
                    d_time: '',
                    remarks: '',
                    phone_no: '',
                    token_id: '',
                    status_f: '',
                    status_c: '',
                    under_inquiry: '',
                    paid_quiry: '',
                    weapon: '',
                    witness: '',
                    crime_news: '',
                    name: '',
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage("خرابی: " + result.message);
            }
        } catch (error) {
            console.error("فارم جمع کرانے میں خرابی:", error);
            setMessage("فارم جمع کرانے کے دوران ایک خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔");
        }
    };

    return (
        <div className="lc-form-container" style={{ direction: 'rtl' }}>
            <form className="lc-formfir" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className='lc-form-group'>
                        <label className='lc-label'>بنام:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>الزام یا اطلاع:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="crime_news"
                                value={formData.crime_news}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'> گواہان:</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input lc-textarea'
                                name="witness"
                                value={formData.witness}
                                onChange={handleChange}
                                // placeholder="نام و اطلاع دہندہ درج كریں..."
                                dir="rtl"
                            ></textarea>
                        </div>
                    </div>

                    {/* <div className='lc-form-group'>
                        <label className='lc-label'>گواہان:</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input'
                                name="witness"
                                value={formData.witness}
                                onChange={handleChange}
                                rows="3"
                                style={{
                                    resize: "vertical",
                                    minHeight: "80px",
                                    width: "100%",
                                    borderRadius: "6px",
                                    padding: "12px",
                                }}
                            ></textarea>
                        </div>
                    </div> */}
                </div>

                <div className="lc-right-section">
                    <div className='lc-form-group'>
                        <label className='lc-label'>زیر حراست:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="under_inquiry"
                                value={formData.under_inquiry}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'>ضمانت یا مچلکہ پر:</label>
                        <div className="lc-input-container">
                            <input
                                className='lc-input'
                                type="text"
                                name="paid_quiry"
                                value={formData.paid_quiry}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className='lc-form-group'>
                        <label className='lc-label'> مال معہ ہتھیار باز یافتہ مقام ووقت پرآمدگی کس نے برآمد کیا عدالت میں بھیجا گیا یا نہیں:</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input lc-textarea'
                                name="weapon"
                                value={formData.weapon}
                                onChange={handleChange}
                                // placeholder="نام و اطلاع دہندہ درج كریں..."
                                dir="rtl"
                            ></textarea>
                        </div>
                    </div>

                    {/* <div className='lc-form-group'>
                        <label className='lc-label'>مال معہ ہتھیار باز یافتہ مقام ووقت پرآمدگی کس نے برآمد کیا عدالت میں بھیجا گیا یا نہیں:</label>
                        <div className="lc-input-container">
                            <textarea
                                className='lc-input'
                                name="weapon"
                                value={formData.weapon}
                                onChange={handleChange}
                                rows="3"
                                style={{
                                    resize: "vertical",
                                    minHeight: "80px",
                                    width: "100%",
                                    borderRadius: "25px",
                                    padding: "12px",
                                }}
                            ></textarea>
                        </div>
                    </div> */}
                </div>
                
            </form>

            <button
                        type="submit"
                        className="lc-submit-btn"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            marginTop: "20px"
                        }}
                        >
                        {/* <i className="fas fa-save"></i> */}
                        <span>Save</span>
                    </button>
            {/* {barcodeImage && (
                <div className="lc-barcode-container">
                    <img className="lc-barcode" src={barcodeImage} alt="بارکوڈ" />
                </div>
            )} */}

            {showPopup && (
                <div className="lc-popup">
                    Data Saved Successfully !
                </div>
            )}
        </div>
    );
};

export default Challan_f;